import { render, staticRenderFns } from "./DocFlat.vue?vue&type=template&id=406ac452"
import script from "./DocFlat.vue?vue&type=script&lang=js"
export * from "./DocFlat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports